import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { APP_SETTINGS } from 'angular-engine/modules/ng-express-engine/tokens';

declare const grecaptcha: any;

@Injectable()
export class RecaptchaEnterpriseService {
  private siteKey: string;

  constructor(
    @Inject(APP_SETTINGS) private settings: any,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.siteKey = this.settings['RECAPTCHA_SITE_KEY'] || '';
  }

  hasSiteKey(): boolean {
    return !!this.siteKey;
  }

  execute(action: string): Promise<string> {
    if (isPlatformServer(this.platformId) || !this.siteKey || typeof grecaptcha === 'undefined' || !grecaptcha.execute) {
      return Promise.resolve('');
    }

    return new Promise((resolve, reject) => {
      try {
        grecaptcha.ready(() => {
          grecaptcha.execute(this.siteKey, { action })
            .then((token: string) => resolve(token || ''))
            .catch((err: any) => reject(err));
        });
      } catch (err) {
        reject(err);
      }
    });
  }

  /**
   * Appends the recaptcha token to the provided FormData and returns it.
   * Components can await this before submit to avoid boilerplate token handling.
   */
  appendToken(formData: FormData, action: string): Promise<FormData> {
    return this.execute(action)
      .then((token: string) => {
        formData.set('g-recaptcha-response', token || '');
        return formData;
      })
      .catch((err: any) => {
        formData.set('g-recaptcha-response', '');
        return Promise.reject(err);
      });
  }
}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/utils/recaptcha-enterprise.service.ts